import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  /** The sentence the API gave for refusing the invitation. */
  reason: string;
  /** Label of the role chosen in the form, for the replace action. */
  roleLabel: string;
  busy?: boolean;
  /** Send the pending invitation again, unchanged. */
  onResend: () => void;
  /** Replace the pending invitation with the one in the form. */
  onReplace: () => void;
}

/**
 * Shown in the invite form when the address already has a pending invitation.
 * Nothing is replaced until the user picks one of the two actions.
 */
const PendingInvitationNotice: React.FC<Props> = ({
  reason,
  roleLabel,
  busy = false,
  onResend,
  onReplace,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className='teamPendingInvite'
      role='alert'
      data-testid='team-pending-invite'
    >
      <p className='teamPendingInvite__reason'>
        {reason || t('InvitePendingReason')}
      </p>
      <div className='teamPendingInvite__actions'>
        <button
          type='button'
          className='drawerBtn drawerBtn--ghost'
          onClick={onResend}
          disabled={busy}
        >
          {t('ResendInvitation')}
        </button>
        <button
          type='button'
          className='drawerBtn drawerBtn--primary'
          onClick={onReplace}
          disabled={busy}
        >
          {t('InvitePendingReplace', { role: roleLabel })}
        </button>
      </div>
    </div>
  );
};

export default PendingInvitationNotice;
